import {useFlags} from '@product-web/flags'

import {isOnNewPricingPlan} from '~/feature-people/add-modals/add-members/helpers'

import type {PlanSelectionModalProps} from './plan-selection-modal'
import {PlanSelectionModal} from './plan-selection-modal'

import {bff} from '../bff'
import {ChoosePlanContainer} from '../manage-plan/choose-plan-container'

export const PlanSelectionModalWrapper = (props: PlanSelectionModalProps) => {
    const {newPlanSelectionModal} = useFlags()
    const {data: companySubscription, isLoading} =
        bff.paywall.planSelectionModal.getCompanySubscription.useQuery()

    if (isLoading) {
        return null
    }

    if (
        newPlanSelectionModal &&
        isOnNewPricingPlan(companySubscription?.platformRatePlan.type) &&
        !companySubscription?.isInTrialPeriod
    ) {
        return <PlanSelectionModal {...props} />
    }

    return <ChoosePlanContainer {...props} trackingOrigin={props.pageSection} />
}
